import SeoHead from '../components/SeoHead';
import { COMPANY } from '../data/seedData';

export default function HandelsbetingelserPage() {
  const pdfUrl = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/salgs_og_leveringsbetingelser_rb.pdf';

  return (
    <>
      <SeoHead
        title="Handelsbetingelser - RB Glasfiber A/S"
        description="Salgs- og leveringsbetingelser for RB Glasfiber A/S."
        canonical="https://www.rb-glasfiber.dk/handelsbetingelser"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-file-contract"></i>
              <span>Vilkår & Betingelser</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Salgs- og leveringsbetingelser
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Gældende for alle aftaler og leverancer fra RB Glasfiber A/S.
            </p>

            <div className="mt-6">
              <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 rounded bg-[#1e9457] hover:bg-[#15703f] text-white text-xs font-bold uppercase tracking-wider transition-colors shadow"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Download salgs- og leveringsbetingelser (PDF)</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Legal Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed text-sm sm:text-base">
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Generelt</h2>
              <p>
                For alle salgsaftaler gælder nedenstående betingelser, for så vidt der ikke er ufravigelige lovbestemmelser. Købers egne indkøbsbetingelser forpligter ikke RB Glasfiber A/S, medmindre andet er aftalt og skriftligt bekræftet af RB Glasfiber A/S.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Tilbud</h2>
              <p>
                Tilbud er bindende i 2 måneder fra tilbuddets dato at regne, medmindre andet udtrykkeligt fremgår af tilbuddet.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Priser</h2>
              <p>
                Der tages forbehold for prisstigninger på råvarer, transport, ændringer i valutakurser eller indførelse af offentlige afgifter af enhver art, der måtte ligge udenfor RB Glasfiber A/S’ indflydelse, og som indtræffer efter afsendelse af ordrebekræftelsen. RB Glasfiber A/S er således berettiget til på leveringsdagen at ændre priserne i overensstemmelse med ændringer i indkøbspriser, transportomkostninger, valutakurser, offentlige afgifter af enhver art og andre forhold, som ligger uden for RB Glasfiber A/S’ kontrol og indflydelse. Der tillægges miljøtillæg, samt opstartsgebyr ved mindre ordre i specialfarve og ved udviklingsarbejde. Tillæg og gebyrer oplyses ved henvendelse.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Ejendomsret</h2>
              <p>
                RB Glasfiber A/S forbeholder sig ejendomsretten til det leverede, indtil fuld betaling er præsteret. RB Glasfiber A/S er i tilfælde af købers betalingsmora berettiget til uden forudgående varsel at afhente det leverede, og køber er forpligtet til at foretage udlevering. Ved tilbagetagelse i henhold til ejendomsforbeholdet skal køber erstatte RB Glasfiber A/S ethvert tab og samtlige omkostninger, herunder advokatomkostninger, som RB Glasfiber A/S måtte blive påført. Køber er uberettiget til at foretage videresalg, pantsætning, udlån, udlejning eller lignende af det leverede eller lade det leverede indføje i fast ejendom på en sådan måde, at ejendomsforbeholdet ikke kan opretholdes, indtil fuld betaling er sket. Foretages der retsforfølgning imod det leverede fra tredjemand, herunder udlæg, er køber forpligtet til straks at give RB Glasfiber A/S meddelelse herom. Forme tilhører RB Glasfiber A/S med mindre ejendomsrettigheden overdrages skriftligt.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Betalingsbetingelse</h2>
              <p>
                Sidste rettidige betalingsdag fremgår af fakturateksten. Erlægges betaling ikke rettidigt, beregnes en rente på 2 % pr. påbegyndt måned, regnet fra den angivne forfaldsdag. I tilknytning hertil kan RB Glasfiber A/S kræve godtgørelse for rykkergebyr, inkassogebyr og andre udgifter knyttet til inddrivelsen af betalingen.
              </p>
              <p className="mt-3">
                Købers pligt til at betale rettidigt består, selv om køber reklamerer over fejl og mangler, alternativt skal køber deponere købesummen i tilfælde af, at der påberåbes fejl eller mangler. Køber er under alle omstændigheder forpligtet til at betale rettidigt for den del af leverancen, som ikke er behæftet med fejl eller mangler. Køber er ikke berettiget til at modregne.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Levering, mangler og reklamation</h2>
              <p>
                <strong>Leveringssted:</strong> Såfremt andet ikke udtrykkeligt er skriftligt aftalt, sker levering ab lager.
              </p>
              <p className="mt-3">
                <strong>Købers undersøgelsespligt og reklamationspligt:</strong> Det påhviler køber grundigt at undersøge varen straks ved modtagelsen. Hvis køber konstaterer eller burde konstatere, at det leverede lider af mangler, skal køber skriftligt gøre manglen gældende, og den konstaterede mangel skal noteres på medfølgende fragtbrev. Senest 8 dage efter leveringen, og før varen tages i brug, skal reklamationen være fremsat skriftligt over for RB Glasfiber A/S. Ved påsætning af hjul anses varen for taget i brug. Reklamerer køber ikke rettidigt, bortfalder købers ret til at gøre manglen gældende. Har køber ikke inden 12 måneder efter det leveredes overgivelse til køber meddelt RB Glasfiber A/S, at køber vil påberåbe sig mangler, kan køber ikke senere gøre dem gældende, medmindre RB Glasfiber A/S skriftligt har påtaget sig at indestå for genstanden i længere tid eller har handlet svigagtigt.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Omlevering og afhjælpning</h2>
              <p>
                Ved berettiget og rettidig reklamation påtager RB Glasfiber A/S sig inden rimelig tid efter modtagelse af reklamationen, efter egen bedømmelse og valg, at ombytte eller reparere den vare, som køber godtgør, er mangelfuld. Hvis RB Glasfiber A/S foretager rettidig omlevering eller afhjælpning, er køber uberettiget til at hæve aftalen eller kræve erstatning eller anden kompensation som følge af manglen.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Forsinkelse</h2>
              <p>
                Foreligger der forsinkelse fra RB Glasfiber A/S’ side med hensyn til levering af det solgte, og ønsker køber at gøre misligholdelsesbeføjelser gældende, skal køber, inden 2 hverdage efter at forsinkelsen er indtrådt, give RB Glasfiber A/S et rimeligt varsel til at foretage levering. Forsinket levering berettiger uanset årsag ikke køber til erstatning for hverken direkte eller indirekte tab.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Produktansvar & Force Majeure</h2>
              <p>
                RB Glasfiber A/S er kun ansvarlig for personskade forvoldt af de leverede produkter, hvis det dokumenteres, at skaden skyldes fejl eller forsømmelser begået af RB Glasfiber A/S eller andre, som RB Glasfiber A/S har ansvaret for. RB Glasfiber A/S er ikke ansvarlig for skade på fast ejendom eller løsøre, ligesom RB Glasfiber A/S ikke er ansvarlig for driftstab, avancetab, tabt arbejdsfortjeneste eller andre indirekte tab.
              </p>
            </div>

            <div className="border-t border-slate-200 pt-6">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 uppercase tracking-tight">Tvister</h2>
              <p>
                Enhver tvist mellem parterne afgøres ved de ordinære domstole i Danmark og ved anvendelse af dansk ret.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
